import { Directive, ElementRef, Input, HostListener, AfterViewInit, inject } from '@angular/core';

@Directive({
  selector: '[focusInput]',
  standalone: true, 
})
export class FocusInputDirective implements AfterViewInit {
  @Input() focusInput: boolean = false;
  private element = inject(ElementRef)
  //constructor(private element: ElementRef) {}

  ngAfterViewInit() {
    if (this.focusInput) {
      this.element.nativeElement.focus();
    }
  }

  ngOnChanges() {
    if (this.focusInput) {
      setTimeout(() => this.element.nativeElement.focus(), 0);
    }
  }

  @HostListener('blur')
  onBlur() {
    this.focusInput = false;
  }
}
